import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { ContactsStore } from "@store/contacts";
import { ConstantsStore } from "@store/constants";
import { DiscountType } from "@models/discount-type";
import { Contact } from "@models/contact";
import { ApplyDiscountParams } from "@services/contact";
import * as moment from "moment";
import { Campus } from "@models/campus";
import { Utilities } from "@helpers/utilities";
import {
  APPLY_DISCOUNT,
  APPLIED_DISCOUNT
} from "@reducers/contacts";
import { ModalService } from "@services/modal";

@Component({
  selector: 'add-discount-form',
  templateUrl: './add-discount-form.pug',
})
export class AddDiscountFormComponent implements OnInit, OnDestroy {

  private contactsSubscription: Subscription
  private constantsSubscription: Subscription

  public startDateStr: string
  public endDateStr: string
  public transactionDateStr: string

  public student: Contact
  public discountTypes: DiscountType[]
  public campuses: Campus[]
  public params: ApplyDiscountParams

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.contactsSubscription =
      this.store.select("contactsReducer")
        .subscribe((s: ContactsStore) => {
          this.student = s.activeContact
        })

    this.constantsSubscription =
      this.store.select("constantsReducer")
        .subscribe((s: ConstantsStore) => {
          this.discountTypes = s.constants.discountTypes
          this.campuses = s.constants.campuses
        })

    this.setupInitialState()
  }

  setupInitialState() {
    const endDate = moment(new Date()).add(9, "weeks").toDate()

    this.transactionDateStr =
      Utilities.getDateInInputStringFormat(new Date())
    this.startDateStr =
      Utilities.getDateInInputStringFormat(new Date())
    this.endDateStr =
      Utilities.getDateInInputStringFormat(endDate)

    this.params = {
      studentId: this.student.id,
      discountType: this.discountTypes[0].discountType,
      transactionDate: new Date(),
      startDate: new Date(),
      endDate: endDate,
      fixedAmount: 0,
    }
  }

  getCampus(id: number): Campus {
    return this.campuses.find((c) => c.id == id)
  }

  clickedDiscountType(dt: DiscountType) {
    this.params.discountType  = dt.discountType
    this.params.fixedAmount   = 0
  }


  setDate(target: string, dateStr: string) {
    this.params[target] = new Date(dateStr)
  }

  isDiscountTypeSelected(dt: DiscountType): boolean {
    return this.params.discountType == dt.discountType
  }

  isFixedDiscountSelected(): boolean {
    const fixedDt = this.discountTypes.find((dt) => {
      return dt.description == "Fixed Discount"
    })
    return this.params.discountType == fixedDt.discountType
  }
 
  isFormValid(): boolean {
    let result = true
    
    if (this.isFixedDiscountSelected() && this.params.fixedAmount <= 0) {
      result = false
    }
    
    if (this.params.startDate > this.params.endDate) {
      result = false
    }

    return result
  }

  clickedSubmit() {
    if (this.isFormValid()) {
      this.actions
        .ofType(APPLIED_DISCOUNT)
        .take(1)
        .subscribe(() => this.modalService.closeModal())
      this.store.dispatch({ type: APPLY_DISCOUNT, payload: this.params })
    }
  }

  ngOnDestroy() {
    this.contactsSubscription.unsubscribe()
    this.constantsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/add-discount-form.ts